// extracted by mini-css-extract-plugin
export const footerLinks = "footer-module--footer-links--RM8M_";
export const socialMediaContainer = "footer-module--socialMediaContainer--3L7fn";
export const socialMediaLink = "footer-module--socialMediaLink--1fQmX";
export const linkGroup = "footer-module--link-group--2ATh1";
export const builtWith = "footer-module--built-with--2-FK5";
export const footerLogos = "footer-module--footer-logos--3zPwg";
export const copyright = "footer-module--copyright--hhCzN";
export const linkSection = "footer-module--link-section--3xef3";